<template>
  <div>
    <v-card elevation="3">
      <v-breadcrumbs :items="items" divider class="hvh-breadcrumbs">
        <template v-slot:item="props">
          <li :class="stepClass(props.item)">
            <v-avatar size="30" class="mr-2 hvh-step-number">
              <span v-if="itemIndex(props.item) < parseInt(currentStep, 10)">
                <v-icon>mdi-check</v-icon>
              </span>
              <span v-else>{{ itemIndex(props.item) }}</span>
            </v-avatar>
            <span class="hvh-step-text">{{ props.item.text }}</span>
          </li>
        </template>
      </v-breadcrumbs>
    </v-card>
  </div>
</template>

<script> 
export default {
  props: ['currentStep', 'items'],
  methods: {
    itemIndex(item) {
      return this.items.findIndex((i) => i === item) + 1;
    },
    stepClass(item) {
      if (this.itemIndex(item) < parseInt(this.currentStep, 10)) {
        return 'hvh-step--completed';
      }
      if (this.itemIndex(item) === parseInt(this.currentStep, 10)) {
        return 'hvh-step--current';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hvh-breadcrumbs {
  justify-content: center;
}

.hvh-chip--white {
  background: $color-white;
  color: $color-teal;
}

.hvh-step-number {
  color: $color-white;
  background: $color-gray-2;
  font-weight: bold;
  font-size: rem(16px);

  span {
    margin-top: -2px;
  }

  .v-icon::before {
    color: $color-white;
  }
}

.hvh-step-text {
  font-weight: 600;
  color: $color-gray-2;
}

.hvh-step--completed {
  .hvh-step-number {
    background: $color-teal;
  }

  .hvh-step-text {
    color: $color-black;
  }
}

.hvh-step--current {
  .hvh-step-number {
    background: $color-teal;
  }

  .hvh-step-text {
    color: $color-teal;
  }
}
</style>